import React from 'react';
import OdfjellInputComponent from '../../../common/odfjell-input-component/OdfjellInputComponent';

interface LastCargoesNumberSelectorProps {
    lastCargoesNumberOfSteps: number;
    setLastCargoesNumberOfSteps: (value: number) => void;
    disabled?: boolean;
}

const LastCargoesNumberSelector: React.FC<LastCargoesNumberSelectorProps> = ({ lastCargoesNumberOfSteps, setLastCargoesNumberOfSteps, disabled }) => {
    // Create options for numbers 3 to 10
    const numberOptions = Array.from({ length: 8 }, (_, i) => ({
        value: (i + 3).toString(),
        label: (i + 3).toString(),
    }));

    const handleChange = (changeObject) => {
        if (changeObject.event && changeObject.event.target) {
            const selectedNumber = parseInt(changeObject.event.target.value);
            if (!isNaN(selectedNumber)) {
                setLastCargoesNumberOfSteps(selectedNumber);
            }
        }
    };
    return (
        <OdfjellInputComponent
            type="select"
            name="lastCargoesSteps"
            description="Number of Previous Cargoes"
            value={lastCargoesNumberOfSteps.toString()}
            options={numberOptions}
            onChange={handleChange}
            disabled={disabled}
        />
    );
};

export default LastCargoesNumberSelector;
